import { createBrowserRouter, RouterProvider } from "react-router-dom";
import "./App.scss";
import ROUTES from "./routes/routes";
import { Provider } from "react-redux";
import store, { persistor } from "./redux/store";
import "./assets/styles/some_pages.scss";
import { ToastContainer } from "react-toastify";
import { PersistGate } from "redux-persist/integration/react";
import { useEffect } from "react";
import { getStoredRef } from "./utils/utils";

const router = createBrowserRouter(ROUTES, {
  future: {
    v7_startTransition: true,
    v7_relativeSplatPath: true,
    v7_normalizeFormMethod: true,
    v7_fetcherPersist: true,
    v7_partialHydration: true,
    v7_skipActionErrorRevalidation: true,
  } as any,
});

function App() {
  useEffect(() => {
    // Check ref TTL immediately on mount, then every 30 seconds
    getStoredRef();
    const interval = setInterval(() => {
      getStoredRef();
    }, 30 * 1000);
    return () => clearInterval(interval);
  }, []);

  useEffect(() => {
    const clearOnlyTranslationData = () => {
      const persistedRoot = localStorage.getItem("persist:root");
      if (!persistedRoot) return;
      try {
        const parsed = JSON.parse(persistedRoot);
        delete parsed.translationData;
        localStorage.setItem("persist:root", JSON.stringify(parsed));
      } catch (e) {
        console.error("Error parsing persist:root", e);
      }
    };

    window.addEventListener("beforeunload", clearOnlyTranslationData);
    return () => {
      window.removeEventListener("beforeunload", clearOnlyTranslationData);
    };
  }, []);

  return (
    <Provider store={store}>
      <PersistGate loading={null} persistor={persistor}>
        <div className="App">
          <RouterProvider router={router} />
          <ToastContainer style={{ zIndex: "999999999999" }} />
        </div>
      </PersistGate>
    </Provider>
  );
}

export default App;
